import Loadable from 'pages/AsyncLoadable';
import { NameFormContainer } from 'components/NameForm';
import { EmailFormContainer } from 'components/EmailForm';
import { AddPhoneFormContainer } from 'components/PhoneForm';
import { AddressFormContainer } from 'components/AddressForm';
import { NotificationsFormContainer } from 'components/NotificationsForm';

export const AsyncPageName = Loadable({
  loader: () => import(/* webpackChunkName: 'name' */ './Name'),
});
AsyncPageName.fetchData = NameFormContainer.fetchData;

export const AsyncPageEmail = Loadable({
  loader: () => import(/* webpackChunkName: 'email' */ './Email'),
});
AsyncPageEmail.fetchData = EmailFormContainer.fetchData;

export const AsyncPagePhone = Loadable({
  loader: () => import(/* webpackChunkName: 'phone' */ './Phone'),
});
AsyncPagePhone.fetchData = AddPhoneFormContainer.fetchData;

export const AsyncPageVerifyPhone = Loadable({
  loader: () => import(/* webpackChunkName: 'verify-phone' */ './VerifyPhone'),
});

export const AsyncPageAddress = Loadable({
  loader: () => import(/* webpackChunkName: 'address' */ './Address'),
});
AsyncPageAddress.fetchData = AddressFormContainer.fetchData;

export const AsyncPageAddressSearchResults = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: 'address-search-results' */ './AddressSearchResultsPage'
    ),
});

export const AsyncPagePassword = Loadable({
  loader: () => import(/* webpackChunkName: 'password' */ './Password'),
});

export const AsyncPageDonationHistory = Loadable({
  loader: () =>
    import(/* webpackChunkName: 'donation-history' */ './DonationHistory'),
});

export const AsyncPagePaymentMethods = Loadable({
  loader: () =>
    import(/* webpackChunkName: 'notifications' */ './PaymentMethods'),
});

export const AsyncPageNotifications = Loadable({
  loader: () =>
    import(/* webpackChunkName: 'notifications' */ './Notifications'),
});
AsyncPageNotifications.fetchData = NotificationsFormContainer.fetchData;

export const AsyncPageNotFound = Loadable({
  loader: () => import(/* webpackChunkName: 'not-found' */ './NotFound'),
});

export default {
  AsyncPageName,
  AsyncPageEmail,
  AsyncPagePhone,
  AsyncPageVerifyPhone,
  AsyncPageAddress,
  AsyncPageAddressSearchResults,
  AsyncPagePassword,
  AsyncPageDonationHistory,
  AsyncPagePaymentMethods,
  AsyncPageNotifications,
  AsyncPageNotFound,
};
